/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../docsAndForms/docs-and-forms.models.ts" />
/// <reference path="../docsAndForms/docs-and-forms.service.ts" />
/// <reference path="../../components/fileUpload/fileUpload.service.ts" />

module Meevo.Plugins.ClientIntakeForm {

    import MeevoFileUploadService = Meevo.Components.FileUpload.MeevoFileUploadService;
    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import DocsAndFormsCreationTypeEnum = Meevo.Plugins.DocsAndForms.DocsAndFormsCreationTypeEnum;
    import IDocsAndFormAssignedCFF = Meevo.Plugins.DocsAndForms.IDocsAndFormAssignedCFF;
    import FormTypeEnum = Meevo.Model.FormTypeEnum;
    import DocsAndFormsService = Meevo.Plugins.DocsAndForms.DocsAndFormsService;

    const clientIntakeFormMainSectionID = 0;
    const formBuilderSectionID = 1;

    interface IBusinessType  {
        businessType_TId: string;
        tenantId: number;
        businessType_SId: number;
        entityVersion: number;
        externalId: string;
        displayName: string;
    }

    interface ICIFSelectedSection extends Meevo.Components.CommonClasses.ICommonSection {
        model: IIntakeFormModel;
    }

    export class ClientIntakeFormContext extends Meevo.Components.CommonClasses.CommonContextBase {
        selectedSection: ICIFSelectedSection;

        public fileTypesEnum = Meevo.Model.FileTypes;
        public bizType = null;
        public businessTypes: IBusinessType[];

        public get isBusinessTypeVisible(): boolean {
            return (this.businessTypes || []).filter((businessType) => businessType.businessType_TId !== null).length > 1;
        }

        public isSectionWithBuilderModel(id: number): boolean {
            return id === clientIntakeFormMainSectionID || id === formBuilderSectionID;
        }

        get formBuilderUrl(): string {
            return this.$sce.trustAsResourceUrl(`${this.appSettings.MEEVO_MODULES_URL}/${this.appSettings.ROUTE_NAMES.newIntakeFormBuilder}/builder?businessTypeId=${this.bizType}`);
        }

        get itemId(): string {
            return this.selectedSection.model.id;
        }

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected clientIntakeFormService: ClientIntakeFormService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityChecker: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: ng.translate.ITranslateService,
            protected docsAndFormsRenderService: Meevo.Plugins.DocsAndForms.DocsAndFormsRenderService,
            protected $sce: ng.ISCEService,
            protected $scope: ng.IScope,
            protected docsAndFormsService: Meevo.Plugins.DocsAndForms.DocsAndFormsService,
            private _dataService: Meevo.Components.BaseClasses.IDataService,
            private _systemTagsService: Meevo.Plugins.DocsAndForms.SystemTagsFactory
        ) {

            super(appSettings, clientIntakeFormService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.clientIntakeFormBuilder;
            this.sectionTemplatePath = 'app/plugins/clientIntakeForm/sectionViews/';
            this.initializeSections();
            this.getBusinessTypes().then(() => {
                this.activate();
            });

            this.$scope.$on(Meevo.Components.Common.Messages.CLOSE_INTAKE_FORM_DESIGNER, () => {
                this.$scope.$apply(() => {
                    this.getSectionData(<ClientIntakeFormMainSection>this.selectedSection, this.bizType);
                });
            });

            this.headerContent = this.$translate.instant('LABEL_CLIENT_INTAKE_FORM');
        }

        initializeSections() {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_CLIENTINTAKEFORMBUILDER_TAB_FORMBUILDER + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(
                    new ClientIntakeFormMainSection(
                        clientIntakeFormMainSectionID,
                        'SECTION_FORM_BUILDER',
                        'main.html',
                        true,
                        true,
                        this.appSettings.API_ENDPOINTS.clientIntakeFormBuilder,
                        '',
                        this.loggingService,
                        this.identityService,
                        Meevo.Model.NounEnum.ClientIntakeFormBuilderTab,
                        this.busyService,
                        this.modalService,
                        this.securityKeys.MANAGEMENT_CLIENTINTAKEFORMBUILDER_TAB_FORMBUILDER + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        this.$translate,
                        this.$scope,
                        this.trackingService,
                        this.clientIntakeFormService,
                        this.docsAndFormsService,
                        this._dataService,
                        this._systemTagsService
                    )
                );
            }
        }

        showEditLogic(): boolean {
            return this.isReadonly;
        }

        canEditLogic(): boolean {
            return this.selectedSection !== null && this.isReadonly;
        }

        canSaveLogic(): boolean {
            return this.isEditing;
        }

        canCancelLogic(): boolean {
            return this.isEditing;
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        selectSection(section): void {
            super.selectSection(section);

            if (this.isSectionWithBuilderModel(section.sectionId) && !this.navigationBlocked) {
                this.getSectionData(<ClientIntakeFormMainSection>section, this.bizType);
            }
        }

        getImageUrl(model: IIntakeFormModel = <IIntakeFormModel>{}): string {
            return MeevoFileUploadService.getImageUrl((model || <IIntakeFormModel>{}).meevoFile);
        }

        save(): angular.IPromise<any> {
            return this.docsAndFormsRenderService
                .generateHTMLDefaultIntakeTemplate(this.$scope)
                .then(html => {
                    if (!this.selectedSection.model.templateHTML) {
                        this.selectedSection.model.templateHTML = html;
                    }

                    const duplicates: IUserDefinedControl[] = Meevo.Plugins.DocsAndForms.DocsAndFormsRenderService
                        .getControlDuplicates(this.selectedSection.model, (<ClientIntakeFormMainSection>this.selectedSection).formBuilderModel.assignedUDFs);
                    if (duplicates.length > 0) {
                        this.modalService.alert(this.$translate.instant('ALERT_CLIENT_INTAKE_FORM_HAS_CONTROL_DUPLICATES', {
                            ControlName: duplicates[0].controlName
                        }));

                        return null;
                    }

                    const unknownControlsNames: string[] = Meevo.Plugins.DocsAndForms.DocsAndFormsRenderService
                        .getUnknownControlNames(this.selectedSection.model, (<ClientIntakeFormMainSection>this.selectedSection).formBuilderModel.assignedUDFs);
                    if (unknownControlsNames.length > 0) {
                        this.modalService.alert(this.$translate.instant('ALERT_CLIENT_INTAKE_FORM_REMOVED_CONTROL', {
                            ControlName: unknownControlsNames[0]
                        }));

                        return null;
                    }

                    if (this.selectedSection.model.templateHTML) {
                        const missedRequiredTags = this.docsAndFormsRenderService
                            .getMissedRequiredTags(this.selectedSection.model);
                        if (missedRequiredTags.length > 0) {
                            this.modalService.alert(this.$translate.instant('ALERT_CLIENT_INTAKE_FORM_MISSED_TAGS', {
                                ControlName: missedRequiredTags[0].label
                            }));

                            return null;
                        }
                    }

                    if (this.selectedSection.model.hasHTML && this.selectedSection.model.templateHTMLChanged) {
                        this.selectedSection.model.formCreationTypeEnum = DocsAndFormsCreationTypeEnum.CustomHtmlUpload;
                    }

                    const isBuilt = this.selectedSection.model.hasCustomField || this._systemTagsService.formHasSystemTags(this.selectedSection.model);
                    if (!isBuilt) {
                        return this.modalService.alert('WARNING_HTML_DOESNT_CONTAINS_SYS_TAGS');
                    }
                    
                    if (this._systemTagsService.hasInvalidSystemTags(this.selectedSection.model)) {
                        return this.modalService.alert('WARNING_HTML_INVALID_SYS_TAGS');
                    }
                    
                    if (this.selectedSection.model.creationTypeChanged) {
                        const msg = this.$translate.instant('MESSAGE_REPLACE_INTAKE_FORM', {formName: this.selectedSection.model.displayName});

                        return this.modalService.redAlertConfirm(msg)
                            .then(() => super.save());
                    }

                    return super.save();
                });
        }

        businessTypeChanged() {
            if (this.isSectionWithBuilderModel(this.selectedSection.sectionId)) {
                this.getSectionData(<ClientIntakeFormMainSection>this.selectedSection, this.bizType);
            }
        }

        postCancel() {
            super.postCancel();

            if (_.isObject(this.selectedSection['formBuilderModel'])) {
                this.getSectionData(<ClientIntakeFormMainSection>this.selectedSection, this.bizType);
            }
        }

        postUpdate(model) {
            super.postUpdate(model);

            if (_.isObject(this.selectedSection['formBuilderModel'])) {
                this.getSectionData(<ClientIntakeFormMainSection>this.selectedSection, this.bizType);
            }
        }

        private getSectionData(section: ClientIntakeFormMainSection, bizType: string): void {
            this.loadingInProgress = true;
            section.getData(bizType)
                .finally(() => this.loadingInProgress = false);
        }

        private getBusinessTypes() {
            return this.dataService.getListPaged('CustomData/BusinessType', { criteria: { includeAllBusinessTypeItem: true }})
                .then((businessTypes: IBusinessType[]) => {
                    this.businessTypes = businessTypes.map((bizType) => {
                        if (bizType.businessType_TId === '00000000-0000-0000-0000-000000000001') {
                            bizType.businessType_TId = null;
                        }

                        return bizType;
                    });

                    if (!this.isBusinessTypeVisible) {
                        this.bizType = this.businessTypes.filter((businessType) => businessType.businessType_TId !== null)[0].businessType_TId;
                    }
                });
        }
    }
}
